import { hexKey, parseHexKey } from './hexGridMath';

export const networkEdgeKey = (firstKey, secondKey) => (
  [firstKey, secondKey].sort().join('|')
);

const cubeRound = ({ x, y, z }) => {
  let rx = Math.round(x);
  let ry = Math.round(y);
  let rz = Math.round(z);
  const xDifference = Math.abs(rx - x);
  const yDifference = Math.abs(ry - y);
  const zDifference = Math.abs(rz - z);
  if (xDifference > yDifference && xDifference > zDifference) rx = -ry - rz;
  else if (yDifference > zDifference) ry = -rx - rz;
  else rz = -rx - ry;
  return { q: rx, r: rz };
};

export const axialLine = (first, second) => {
  const distance = (
    Math.abs(first.q - second.q)
      + Math.abs(first.q + first.r - second.q - second.r)
      + Math.abs(first.r - second.r)
  ) / 2;
  if (!distance) return [first];
  const firstCube = { x: first.q, y: -first.q - first.r, z: first.r };
  const secondCube = { x: second.q, y: -second.q - second.r, z: second.r };
  return Array.from({ length: distance + 1 }, (_, index) => {
    const amount = index / distance;
    return cubeRound({
      x: firstCube.x + (secondCube.x - firstCube.x) * amount,
      y: firstCube.y + (secondCube.y - firstCube.y) * amount,
      z: firstCube.z + (secondCube.z - firstCube.z) * amount,
    });
  });
};

export const networkEdgesBetween = (firstKey, secondKey) => {
  const cells = axialLine(parseHexKey(firstKey), parseHexKey(secondKey));
  return cells.slice(1).map((cell, index) => (
    networkEdgeKey(hexKey(cells[index].q, cells[index].r), hexKey(cell.q, cell.r))
  ));
};

export const parseNetworkTypeKey = (value) => {
  const separator = value?.indexOf(':') ?? -1;
  if (separator < 1) return null;
  const catalog = value.slice(0, separator);
  const typeId = value.slice(separator + 1);
  if (!['infrastructure', 'connection'].includes(catalog) || !typeId) return null;
  return { catalog, typeId };
};

export const networkTypeKey = (catalog, typeId) => `${catalog}:${typeId}`;

